import { useCallback } from "react";
import Button from "./Button";
import { useTranslations } from "next-intl";
import Loading from "../../common/components/Loading";

const StupidLoadMoreButton = ({
  className,
  fixedLimit,
  loading,
  maxLength,
  arrayLength,
  fetchMore,
}:
  | {
      loading?: boolean;
      className?: string;
      fixedLimit: number;
      arrayLength: number;
      maxLength?: never;
      fetchMore: any;
    }
  | {
      loading?: boolean;
      className?: string;
      fixedLimit?: never;
      arrayLength: number;
      maxLength: number;
      fetchMore: any;
    }) => {
  const t = useTranslations();
  const loadMore = useCallback(async () => {
    return fetchMore({ variables: { offset: arrayLength } });
  }, [fetchMore, arrayLength]);

  if (loading) {
    return <Loading className="border-top" />;
  }

  const hasMore = maxLength
    ? maxLength > arrayLength
    : arrayLength % fixedLimit < arrayLength / fixedLimit;
  if (!hasMore) return null;

  return (
    <div className="load-more-wrapper text-center">
      <Button onClick={loadMore} appearance="secondary" className={className}>
        {t("load_more")}
      </Button>
    </div>
  );
};

export default StupidLoadMoreButton;
